import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=d0e53e1a&scoped=true"
import script from "./MFA.vue?vue&type=script&lang=js"
export * from "./MFA.vue?vue&type=script&lang=js"
import style0 from "./MFA.vue?vue&type=style&index=0&id=d0e53e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e53e1a",
  null
  
)

export default component.exports